module.exports = __webpack_public_path__ + "static/media/message.53850cb8.mp3";